import WelcomeHome from "@/views/Welcome/WelcomeHome";
import WelcomeApply from "@/views/Welcome/WelcomeApply";

export default [
  {
    path: "",
    name: "WelcomeHome",
    redirect: { name: "WelcomeHomeSelf" },
    component: { render: h => h("router-view") },
    children: [
      {
        path: "home",
        name: "WelcomeHomeSelf",
        component: WelcomeHome,
        // permission: "",
        meta: {
          title: "极客-欢迎"
        }
      },
      {
        path: "apply",
        name: "WelcomeApply",
        component: WelcomeApply,
        // permission: "",
        meta: {
          title: "极客-招募页"
        }
      }
    ]
  }
];
